export function cleanUrlFromDomain(url: string): string {
  if (!url) return "";

  const cleaned = url.startsWith("/") ? url.slice(1) : url;

  const segments = cleaned.split("/");
  if (segments.length > 1) {
    segments.shift();
    return "/" + segments.join("/");
  }

  return url;
}

export function formatUrlForDisplay(url: string): string {
  return cleanUrlFromDomain(url);
}
